import { useEffect, useState, useRef } from "react";

import styles from "./profilePage.module.css";
import ImgBuilder from "../../assets/ImgBuilder";

// import AppBar from "../../components/appBar/appBar";
// import AbortGame from "../../components/abortGame/abortGame";

// import { useNavigate } from "react-router-dom";
import { getStatistics } from "../../api/api";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useUserData } from '../../functions/updateUserData';
import { renderWithLineBreaksAndBold } from '../../functions/renderWithLineBreaksAndBold';

const ProfilePage = () => {
  // const navigate = useNavigate();
  const { t } = useTranslation();
  const { userData, setUserData } = useUserData();
  const [isLoaded, setIsLoaded] = useState(false);
  const navigate = useNavigate();
  const loading = useRef(false);

  useEffect(() => {
    if (loading.current) return; // loading is true, no need for additional calls
    const fetchTopics = async () => {
      loading.current = true;
      try {
        const statistics = await getStatistics(userData.tokens["access_token"], userData.headlineData.trace_id);
        setUserData(prev => ({
          ...prev,
          statistics: statistics
        }));  
      } catch (error) {
        console.error("Failed to fetch statistics about the user:", error);
      } finally{
        loading.current = false;
      }
    };

    fetchTopics();

  }, [userData.tokens, userData.headlineData, setUserData]);

  return (
    <div className={styles.wrapper}>
      {/* <AppBar />
      <AbortGame /> */}
      {userData.statistics &&
      <>
      {!isLoaded && <div className={styles.loader}></div>}
      <img alt="bg" className={styles.bgImg} src={ImgBuilder.dotsBgProfiles}/>
      <div 
        className={styles.container} 
        style={{
        opacity: isLoaded ? 1 : 0,
          transition: "opacity 0.2s ease-in-out",
        }}
      >
        <img alt="folder" onLoad={() => setIsLoaded(true)} className={`${styles.profileFolder} ${styles.relative}`} src={ImgBuilder.profileFolder}/>
        <img alt="profile" onLoad={() => setIsLoaded(true)} className={styles.profileFolder} src={ImgBuilder[t(`profiles.${userData.statistics.player_profile}.asset`)]}/>

        <div className={styles.profileBox}>

          <div className={styles.profileBoxNamePart}>
            <div className={styles.profileBoxUpperRight}>
              <p className={styles.profileBoxNameTitle}>{t(`profiles.${userData.statistics.player_profile}.name`)}</p>
              <p className={styles.profileBoxNameSubtitle}>
                {renderWithLineBreaksAndBold(t(`profiles.${userData.statistics.player_profile}.short_explanation`))}
              </p>
            </div>
          </div>

          <div className={styles.profileBoxNotesPart}>
            <p className={styles.profileBoxNotesTitle}>{t("statistics.notes")}</p>
            <p className={styles.profileBoxNotesSubtitle}>
              {renderWithLineBreaksAndBold(t(`profiles.${userData.statistics.player_profile}.description`))}
            </p>
            <p className={styles.profileBoxNotesMoto}>
              {t(`profiles.${userData.statistics.player_profile}.moto`)}
            </p>
          </div>


        </div>

      </div>
      <div className={styles.buttonsContainer}>
        <button onClick={() => navigate("/survey/game")}  className={styles.button}>{t("statistics.step_before_end")}</button>
      </div>
      </>
      }

      
    </div>
  );
};

export default ProfilePage;
